import React, { HTMLAttributes } from "react";

import Button from "@material-ui/core/Button";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";
import { useComplicatedRolesAndStatuses } from "hooks/useComplicatedRolesAndStatuses";

import useStyles from "./styles";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  onExamButtonClick: () => void;
  assignedUserId: string;
}

const ExamCell = (props: IProps) => {
  const { onExamButtonClick, assignedUserId, ...restProps } = props;

  const classes = useStyles();
  const { isLocked, pullLocker } = useExamLockerContext();
  const { isCurrentUserChiefOrSeniorVet, isCurrentUserAssignedTrackVet } =
    useComplicatedRolesAndStatuses({
      assignedUserId
    });

  const isExamButtonDisabled =
    !(isCurrentUserAssignedTrackVet || isCurrentUserChiefOrSeniorVet) ||
    isLocked;

  const handleClick = async () => {
    const locker = await pullLocker();
    if (locker.data.isLocked) return;

    onExamButtonClick();
  };

  return (
    <TableCellWrapper {...restProps} centered>
      {Boolean(assignedUserId) && (
        <Button
          className={classes.exam}
          size={"small"}
          disabled={isExamButtonDisabled}
          onClick={handleClick}
          startIcon={<AddCircleOutlineIcon className={classes.examIcon} />}
        >
          EXAM
        </Button>
      )}
    </TableCellWrapper>
  );
};

export default React.memo(ExamCell);
